import { render, staticRenderFns } from "./DeckWordsDialog.vue?vue&type=template&id=5675d112&scoped=true&"
import script from "./DeckWordsDialog.vue?vue&type=script&lang=ts&"
export * from "./DeckWordsDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DeckWordsDialog.vue?vue&type=style&index=0&id=5675d112&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5675d112",
  null
  
)

export default component.exports